import { render, staticRenderFns } from "./youtubeList.vue?vue&type=template&id=63424a17&"
import script from "./youtubeList.vue?vue&type=script&lang=js&"
export * from "./youtubeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports